<template>
  <div class="language">
   language
  </div>
</template>

<script>
  export default {
    name: "language",
    data () {
      return{

      }
    }
  }
</script>

<style scoped>
  .el-carousel__item{
    height: auto;
  }
  /deep/ .el-carousel__container{
    height: auto;
  }

  /deep/ .el-carousel__arrow{
    width: 50px;
    height: 50px;
    font-size: 35px;
  }
  .swiper{
    width:100%;
  }
  .swiper .swiper-img{
    width: 100%;
  }
  .product{
    padding:60px 60px 0;
  }
  .product .product-list{
    width:100%;
    margin-top: 60px;
  }
  .product .product-list .list-title {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .product .product-list .list-title .line{
    width: 150px;
    height: 1px;
    background: #b7b7b7;
  }
  .product .product-list .list-title .big-classify{
    font-size: 25px;
    margin: 0 20px;
  }
  .product .product-list .list-intro{
    font-size: 18px;
    color: #777777;
    margin: 30px 0 60px;
    text-align: center;
  }

  .product .product-list .product-ul{
    width: 100%;
    margin-top: 60px;
  }
  .product .product-list .product-ul .list-classify{
    color: #2d69a2;
    font-size: 18px;
    text-align: center;
    margin-bottom: 30px;
  }
  .product .product-list .product-ul .list-box{
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }
  .product-list .product-ul .product-li{
    width:18%;
    margin:0 8px;
  }
  .product-list .product-ul .product-li .product-img{
    width:100%;
  }
  .product-list .product-ul .product-li .product-name{
    font-size: 13px;
    color: #666666;
    text-align: center;
    margin-top:10px;
  }


  .product .contact{
    text-align: center;
    margin: 70px 0 100px;
  }
  .contact-text{
    padding: 5px 20px;
    font-size: 20px;
    border-radius: 5px;
    background: #000;
    color: #fff;
  }
  .product-list.fanghu .product-ul .product-li{
    width:18%;
    margin:0 30px;
  }
  .product-list.xiaodu .product-ul .product-li{
    width:18%;
    margin:0 1%;
  }
  .intro{
    margin-top: 146px;
  }
  .intro .intro-title{
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .intro .intro-title .line{
    width: 120px;
    height: 1px;
    background: #b7b7b7;
  }

  .intro .intro-title .title-content-border{
    width: 200px;
    height: 200px;
    border-radius: 50%;
    margin: 0 50px;
    border: 1px solid #b7b7b7;
    position: relative;
  }
  .intro .intro-title .title-content-box{
    width: 90%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
  }
  .intro .intro-title .title-content-box .title-content{
    font-size: 14px;
    line-height: 30px;
    font-weight: bold;
    text-align: center;
  }
  .intro .office-img{
    display: block;
    width: 90%;
    margin: 80px auto;
  }

  .intro .time{
    width: 100%;
  }
  .intro .time .time-classify{
    width: 100%;
    height: 1px;
    background: #b7b7b7;
    margin-top: 200px;
    position: relative;
  }
  .intro .time .time-classify .time-detail{
    position: absolute;
    transform: translateX(-50%);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    width: 30%;
    height: 120px;
  }
  /*奇数行*/
  .intro .time .time-classify .time-detail:nth-child(odd){
    bottom: -6px;
  }

  /*偶数行*/
  .intro .time .time-classify .time-detail:nth-child(even){
    top: -6px;
  }
  .time .time-classify .time-detail .circle-time{
    height: 50px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
  }
  .time .time-classify .time-detail .circle{
    width:12px;
    height: 12px;
    border-radius: 50%;
    background: #000;
  }
  .time .time-classify .time-detail .time-event{
    width: 100%;
    font-size: 14px;
    overflow-wrap: break-word;
    text-align: center;
    color: #767676;
  }
  .detail-time{
    font-weight: bold;
    font-size: 13px;
  }
  .intro .time .time-classify.time-classify2 .time-detail{
    width: 20%;
  }

  .intro .time .time-classify .time-detail.time2002{
    left:22%;
  }

  .intro .time .time-classify .time-detail.time2009{
    left: 50%;
  }

  .intro .time .time-classify .time-detail.time2011{
    left: 78%;
  }
  .intro .time.last-time{
    margin: 330px 0 230px;
  }
  .intro .time .time-classify .time-detail.time2012{
    left: 16%;
  }

  .intro .time .time-classify .time-detail.time2015-1{
    left: 29.6%;
  }

  .intro .time .time-classify .time-detail.time2015-2{
    left: 43.2%;
  }

  .intro .time .time-classify .time-detail.time2017-1{
    left: 56.8%;
  }

  .intro .time .time-classify .time-detail.time2017-2{
    left: 70.4%;
  }

  .intro .time .time-classify .time-detail.time2020{
    left: 84%;
  }

  .footer{
    border-top: 12px solid #eaeaea;
    padding:30px 70px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .footer .contact .contact-us{
    font-size: 15px;
    font-weight: bold;
  }
  .footer .contact .contact-us-detail{
    font-size: 14px;
    font-weight: normal;
    color: #666;
  }

  .footer .wechat{
    width: 120px;
    text-align: center;
  }

  .footer .wechat .code-img{
    width: 100%;
  }
  .footer .wechat .follow-us{
    font-size: 12px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/language/index.vue